/* Well Rituals — theme.js */

// ── Nav scroll state ──────────────────────────────────────────────
(function () {
  const nav = document.querySelector('.nav');
  if (!nav) return;
  const update = () => nav.classList.toggle('is-scrolled', window.scrollY > 40);
  window.addEventListener('scroll', update, { passive: true });
  update();
})();

// ── Mobile menu toggle ────────────────────────────────────────────
(function () {
  const btn = document.querySelector('.nav__hamburger');
  const links = document.querySelector('.nav__links');
  if (!btn || !links) return;
  btn.addEventListener('click', () => {
    const open = links.classList.toggle('is-open');
    btn.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open);
  });
  links.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      links.classList.remove('is-open');
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  });
})();

// ── Cart drawer ───────────────────────────────────────────────────
(function () {
  const cartBtns = document.querySelectorAll('[data-open-cart]');
  const drawer   = document.querySelector('.wr-drawer');
  const overlay  = document.querySelector('.wr-drawer-overlay');
  const closeBtn = document.querySelector('.wr-drawer__close');
  if (!drawer) return;

  function openCart() {
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    renderCart();
  }
  function closeCart() {
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartBtns.forEach(b => b.addEventListener('click', openCart));
  closeBtn && closeBtn.addEventListener('click', closeCart);
  overlay  && overlay.addEventListener('click', closeCart);

  function renderCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const body    = document.getElementById('wr-drawer-items');
        const foot    = document.getElementById('wr-drawer-foot');
        const shipBar = document.getElementById('wr-drawer-shipbar');
        const FREE_AT = 5000;

        if (!body) return;

        if (cart.item_count === 0) {
          body.innerHTML = '<div class="wr-drawer__empty"><p class="wr-drawer__empty-headline"><em>Your ritual is empty.</em></p><p class="wr-drawer__empty-sub">Begin with one product. Three at most.</p><a href="/collections/all" class="btn btn--gold">Shop the Ritual</a></div>';
          foot && (foot.hidden = true);
          shipBar && (shipBar.hidden = true);
          return;
        }

        const remaining = Math.max(0, FREE_AT - cart.total_price);
        const progress  = Math.min(100, Math.round((cart.total_price / FREE_AT) * 100));

        if (shipBar) {
          shipBar.hidden = false;
          var shipMsg = cart.total_price >= FREE_AT
            ? '<span><strong>✓ Free shipping unlocked.</strong> Ships across Lebanon.</span>'
            : '<span>$<strong>' + (remaining/100).toFixed(0) + '</strong> more for free shipping.</span>';
          shipBar.innerHTML = '<p>' + shipMsg + '</p><div class="wr-drawer__shipbar-track" aria-hidden="true"><span style="width:' + progress + '%"></span></div>';
        }

        var itemsHtml = '';
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          itemsHtml += '<div class="wr-drawer__line" data-key="' + item.key + '">'
            + '<img src="' + item.image + '" alt="" class="wr-drawer__thumb">'
            + '<div class="wr-drawer__line-body">'
            + '<p class="wr-drawer__line-name">' + item.product_title + '</p>'
            + '<p class="wr-drawer__line-meta">' + formatMoney(item.price) + ' · ' + (item.variant_title || '') + '</p>'
            + '<div class="wr-drawer__line-row">'
            + '<div class="wr-drawer__qty">'
            + '<button class="qty-dec" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>'
            + '<span>' + item.quantity + '</span>'
            + '<button class="qty-inc" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>'
            + '</div>'
            + '<button class="wr-drawer__remove" data-key="' + item.key + '" data-qty="0">Remove</button>'
            + '</div></div>'
            + '<span class="wr-drawer__line-price">' + formatMoney(item.line_price) + '</span>'
            + '</div>';
        }
        body.innerHTML = itemsHtml;

        if (foot) {
          foot.hidden = false;
          document.getElementById('wr-drawer-subtotal').textContent = formatMoney(cart.total_price);
        }

        body.querySelectorAll('[data-qty]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            updateLine(btn.dataset.key, parseInt(btn.dataset.qty));
          });
        });
      })
      .catch(function() {
        console.warn('Cart fetch failed');
      });
  }

  function updateLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function() {
      renderCart();
      updateCartCount();
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badge = document.getElementById('cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        }
      });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.variantId;
    if (!id) return;
    btn.disabled = true;
    var orig = btn.textContent;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 }),
    })
    .then(function() {
      btn.textContent = 'Added';
      showToast('Added to your ritual');
      updateCartCount();
      setTimeout(function() {
        btn.textContent = orig;
        btn.disabled = false;
      }, 1600);
    })
    .catch(function() {
      btn.textContent = orig;
      btn.disabled = false;
    });
  });

  window.openCartDrawer = openCart;
  window.renderCart = renderCart;
})();

// ── Toast ────────────────────────────────────────────────────────
function showToast(msg) {
  var el = document.querySelector('.wr-toast');
  if (!el) {
    el = document.createElement('div');
    el.className = 'wr-toast';
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.classList.add('is-visible');
  clearTimeout(el._t);
  el._t = setTimeout(function() { el.classList.remove('is-visible'); }, 2400);
}

// ── Reveal on scroll ─────────────────────────────────────────────
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  els.forEach(function(el) { io.observe(el); });
})();

// ── Newsletter form ───────────────────────────────────────────────
(function () {
  var form = document.querySelector('.newsletter-form');
  if (!form) return;
  var msg = form.querySelector('.newsletter-form__msg');
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var email = form.querySelector('input[type="email"]').value.trim();
    var emailRegex = new RegExp('^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$');
    if (!email || !emailRegex.test(email)) {
      if (msg) { msg.textContent = 'Please enter a valid email address.'; msg.style.color = '#e07070'; }
      return;
    }
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    setTimeout(function() {
      if (msg) { msg.textContent = 'Welcome to the community! Check your inbox soon.'; msg.style.color = ''; }
      form.querySelector('input[type="email"]').value = '';
      if (btn) btn.disabled = false;
    }, 900);
  });
})();
